// --- Pay Plan Templates ---
export const PAY_TYPES = ['salaried', 'commissioned', 'hourly', 'hybrid'];
export const KICKER_BONUS_TYPES = ['percent', 'flat'];
export const BASE_COMMISSION_TYPES = ['percent', 'flat'];
//# sourceMappingURL=index.js.map